
import React from 'react';
import { SVG_ICONS } from '../constants';
import SVGComponent from './SVG/SVGComponent';

import Timezone from './Timezone';

function Header(props) {
  return (
    <div className="header">
      <div className="header__title">Backoffice management system</div>
      <div className="header__wrap">
        <Timezone />
        <div className="header__logout">
          <SVGComponent
            className="icon-xs"
            src={`${SVG_ICONS.homeIcons}#logout`}
            onClick={props.logout}
          />
        </div>
      </div>
    </div>
  );
}
export default Header;
